import React from "react";
import styles from "./CustomPlan.module.css";
import AnimatedBtn from "../../AnimatedBtn/AnimatedBtn";

const CustomPlan = ({ onGoToTop }) => {
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.Innercontainer}>
          {/* Left Section */}
          <div className={styles.leftCard}>
            <h2>
              Custom <br /> Features & <br /> Integrations
            </h2>
            <p className={styles.subHeading}>
              with <span>Enterprise A.I Solutions</span>
            </p>
            <p className={styles.desc}>
              Workflow automation to streamline your operations, reduce human
              costs, and boost productivity.
            </p>
            <div className={styles.imgBox}>
              <img src="/Svg/BookAMeetingIcon.svg" alt="AI Bot" />
            </div>

            <div
              className={styles.BtnDiv}
              onClick={() =>
                window.open(
                  "https://designersx.setmore.com/services/4f9938b2-c221-4c81-b610-f863d7dc8cfb",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              <AnimatedBtn text="Book a Meeting" />
            </div>
          </div>

          {/* Middle Card */}
          <div className={styles.middleCard}>
            <h3>
              Flexible plans for{" "}
              <span className={styles.FLight}> every need</span>
            </h3>

            <div className={styles.liteBox}>
              <div className={styles.liteHeader}>
                <h4>Lite</h4>
                <p>
                  FREE <span>with restriction</span>
                </p>
              </div>
              <p className={styles.liteSub}>Sign up for FREE</p>
              <p className={styles.liteDesc}>
                Includes FREE 20 min + CUSTOM AGENT + VoIP Number + Standard
                features
              </p>
              <div className={styles.iconCircle}>
                <svg
                  width="206"
                  height="206"
                  viewBox="0 0 206 206"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M111.754 156.909C102.689 155.928 93.5737 153.393 84.6651 149.367C80.0239 147.267 74.8796 147.049 70.1638 148.745L66.3054 150.137C65.9637 150.261 65.5847 150.243 65.2492 150.087C64.9199 149.932 64.6652 149.646 64.5471 149.304L55.6563 123.937C55.4575 123.365 55.6563 122.725 56.1471 122.371C56.7498 121.936 57.3711 121.507 57.9925 121.091C85.5168 102.67 112.704 120.712 120.347 122.272C123.267 123.359 125.149 126.031 125.354 128.976L162.695 119.171C166.721 118.115 170.841 120.265 172.276 124.179C173.705 128.087 171.866 132.504 168.076 134.244L122.566 155.077C118.968 156.723 115.214 157.282 111.754 156.909ZM85.796 146.863C94.4383 150.771 103.273 153.231 112.046 154.182C115.165 154.517 118.402 153.964 121.422 152.585L166.938 131.741C169.43 130.598 170.647 127.69 169.703 125.112C168.759 122.533 166.044 121.117 163.397 121.812L124.989 131.896C124.808 132.449 124.56 132.983 124.255 133.487C122.758 135.959 120.037 137.376 117.148 137.183L96.7632 135.823C96.0052 135.773 95.4336 135.121 95.4895 134.363C95.5392 133.611 96.1978 133.014 96.9496 133.089L117.334 134.45C119.198 134.574 120.95 133.661 121.913 132.064C123.535 129.392 122.317 125.913 119.397 124.826C111.164 123.117 85.8092 105.758 59.5207 123.353C59.2101 123.564 58.8994 123.776 58.5888 123.987L66.6781 147.075L69.2379 146.156C74.6122 144.223 80.4964 144.471 85.796 146.863Z"
                    fill="#6524EB"
                  />
                  <path
                    d="M43.9766 158.997L33.5014 129.106C31.8799 124.49 34.3216 119.439 38.9441 117.842L46.1948 115.32C50.78 113.729 55.825 116.158 57.4404 120.737L67.9156 150.628C69.4999 155.127 67.1514 160.147 62.6779 161.812C61.5782 162.234 54.9116 164.539 54.5698 164.608C50.1834 165.819 45.5051 163.34 43.9766 158.997ZM47.1017 117.904L39.8449 120.433C36.6514 121.532 34.9738 125.018 36.0921 128.199L46.5673 158.09C47.6235 161.097 50.8605 162.793 53.9422 161.936C54.4641 161.793 61.1742 159.457 61.6961 159.252C61.7023 159.246 61.7085 159.246 61.7147 159.246C61.7147 159.246 61.7085 159.252 61.7333 159.24C64.815 158.09 66.4304 154.636 65.3431 151.535L54.8679 121.644C53.7496 118.488 50.2642 116.804 47.1017 117.904Z"
                    fill="#6524EB"
                  />
                  <path
                    d="M54.3014 164.626C53.7298 164.626 53.2016 164.266 53.009 163.707L49.7783 154.474C49.4118 153.443 49.4677 152.318 49.9461 151.318C50.4245 150.317 51.2633 149.566 52.3071 149.205L54.9973 148.28C57.1409 147.534 59.4956 148.671 60.2474 150.808L63.4907 160.078C63.7143 160.724 63.4286 161.445 62.8135 161.756C62.4842 161.923 54.9291 164.533 54.5625 164.608C54.4817 164.62 54.3883 164.626 54.3014 164.626ZM56.3517 150.784C56.2026 150.784 56.0473 150.808 55.8982 150.858L53.2079 151.784C52.86 151.902 52.5804 152.157 52.4189 152.492C52.2573 152.828 52.2387 153.207 52.363 153.555L55.1526 161.532C56.5692 161.047 58.9861 160.209 60.4585 159.687L57.6627 151.703C57.4638 151.144 56.9233 150.784 56.3517 150.784Z"
                    fill="#6524EB"
                  />
                  <path
                    d="M75.4794 84.0497C72.2362 76.7306 72.0373 68.5853 74.9203 61.1172C84.594 36.0661 119.599 35.6192 130.29 59.7814C133.527 67.1005 133.726 75.2458 130.843 82.7139C121.17 107.771 86.1727 108.206 75.4794 84.0497ZM77.48 62.1113C74.8582 68.8959 75.0382 76.2896 77.9895 82.9442C87.713 104.895 119.5 104.491 128.29 81.7327C130.912 74.9481 130.732 67.5482 127.787 60.8934C118.058 38.9057 86.2471 39.4021 77.48 62.1113Z"
                    fill="#6524EB"
                  />
                  <path
                    d="M102.881 88.0072C98.0719 88.0072 94.1575 84.0931 94.1575 79.2778C94.1575 78.5199 94.7726 77.9048 95.5306 77.9048C96.2886 77.9048 96.9037 78.5199 96.9037 79.2778C96.9037 82.5832 99.5877 85.2672 102.887 85.2672C106.192 85.2672 108.876 82.577 108.876 79.2778C108.876 75.9787 106.186 73.2947 102.887 73.2947C98.078 73.2947 94.1637 69.3805 94.1637 64.5591C94.1637 62.2293 95.0708 60.0359 96.7173 58.3896C98.3638 56.743 100.557 55.8359 102.887 55.8359C107.702 55.8359 111.616 59.7501 111.616 64.5591C111.616 65.3171 111.001 65.9322 110.243 65.9322C109.485 65.9322 108.87 65.3171 108.87 64.5591C108.87 61.26 106.18 58.576 102.881 58.576C101.284 58.576 99.7804 59.1973 98.6496 60.3281C97.5188 61.4589 96.8974 62.9624 96.8974 64.5593C96.8974 67.8646 99.5814 70.5486 102.881 70.5486C107.696 70.5486 111.61 74.4628 111.61 79.2718C111.61 84.0869 107.696 88.0072 102.881 88.0072Z"
                    fill="#6524EB"
                  />
                  <path
                    d="M102.88 93.2315C102.122 93.2315 101.507 92.6164 101.507 91.8585V86.627C101.507 85.869 102.122 85.2539 102.88 85.2539C103.638 85.2539 104.253 85.869 104.253 86.627V91.8585C104.247 92.6227 103.638 93.2315 102.88 93.2315Z"
                    fill="#6524EB"
                  />
                  <path
                    d="M102.88 58.5756C102.122 58.5756 101.507 57.9605 101.507 57.2025V51.9649C101.507 51.2069 102.122 50.5918 102.88 50.5918C103.638 50.5918 104.253 51.2069 104.253 51.9649V57.2025C104.247 57.9605 103.638 58.5756 102.88 58.5756Z"
                    fill="#6524EB"
                  />
                  <path
                    d="M206 103C206 159.885 159.885 206 103 206C46.1147 206 0 159.885 0 103C0 46.1147 46.1147 0 103 0C159.885 0 206 46.1147 206 103ZM2.94561 103C2.94561 158.259 47.7415 203.054 103 203.054C158.259 203.054 203.054 158.259 203.054 103C203.054 47.7415 158.259 2.94561 103 2.94561C47.7415 2.94561 2.94561 47.7415 2.94561 103Z"
                    fill="#6524EB"
                  />
                </svg>
              </div>
              <button
                className={styles.signBtn}
                onClick={() =>
                  window.open(
                    "https://app.rxpt.ai/",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                Sign up for FREE
              </button>
            </div>
          </div>

          {/* Right Card */}

          <div className={styles.rightCard}>
            <div className={styles.contactBox}>
              <p>Still Confused about the best plan for you?</p>
              <p className={styles.Bold}>
                <strong>CALL REX</strong> on <br />
                <a href="tel:+18886960666">+1 (888) 696-0666</a>
              </p>
            </div>
            <div className={styles.BuildYourPlan}>
              <div className={styles.DFlex}>
                <h4>Build Your Plan</h4>
                <div>
                  <svg
                    width="45"
                    height="42"
                    viewBox="0 0 45 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.1657 5.18681V0.5H6.12151V5.1863C2.94229 5.68099 0.5 8.42838 0.5 11.743C0.5 15.0577 2.94229 17.8056 6.12151 18.2998V41.3837H8.1657V18.2998C11.3439 17.8056 13.7872 15.0582 13.7872 11.743C13.7872 8.42786 11.3439 5.68099 8.1657 5.18681ZM7.14872 16.3424H7.13849C4.60524 16.3399 2.54419 14.2773 2.54419 11.743C2.54419 9.20721 4.60728 7.1436 7.1436 7.1436C9.67993 7.1436 11.743 9.20721 11.743 11.743C11.743 14.2773 9.68197 16.3399 7.14872 16.3424ZM23.4971 23.5829V0.5H21.4529V23.5829C18.2737 24.0776 15.8314 26.8255 15.8314 30.1407C15.8314 33.4553 18.2737 36.2027 21.4529 36.6974V41.3837H23.4971V36.6974C26.6753 36.2027 29.1186 33.4553 29.1186 30.1407C29.1186 26.8255 26.6753 24.0776 23.4971 23.5829ZM22.475 34.7401C19.9387 34.7401 17.8756 32.677 17.8756 30.1407C17.8756 27.6039 19.9387 25.5403 22.475 25.5403C25.0113 25.5403 27.0744 27.6039 27.0744 30.1407C27.0744 32.677 25.0113 34.7401 22.475 34.7401ZM44.45 11.743C44.45 8.42786 42.0067 5.68048 38.8285 5.1863V0.5H36.7843V5.1863C33.6051 5.68099 31.1628 8.42838 31.1628 11.743C31.1628 15.0577 33.6051 17.8056 36.7843 18.2998V41.3837H38.8285V18.2998C42.0067 17.8056 44.45 15.0582 44.45 11.743ZM37.8115 16.3424H37.8013C35.267 16.3399 33.207 14.2773 33.207 11.743C33.207 9.20721 35.2701 7.1436 37.8064 7.1436C40.3427 7.1436 42.4058 9.20721 42.4058 11.743C42.4058 14.2773 40.3448 16.3399 37.8115 16.3424Z"
                      fill="#25242C"
                      stroke="#25242C"
                    />
                  </svg>
                </div>
              </div>

              <p className={styles.planDesc}>
                Choose our Custom Plan to design your own package – freely set
                the minimum amount and duration that best fits your budget and
                needs.
              </p>

              <ul className={styles.planList}>
                <p>Include plans</p>
                <li>✔ Custom Setup</li>
                <li>✔ FREE VoIP Number</li>
                <li>✔ Custom minutes</li>
                <li>✔ Flexible Pricing</li>
                <li>✔ Website Chat & Call Widget</li>
                <li>✔ All Standard Features</li>
              </ul>

              <button className={styles.customBtn} onClick={onGoToTop}>Create Custom Plan</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPlan;
